<div class="authenticate-container">
  <section>
    <div class="left-side">
      <div class="left-side-body">
        <a href="/">
          <img src="assets/images/svg/logo.svg" alt="Logo" />
        </a>
        <div class="title">
          {{ 'We’re upgrading our security system.' | translate }}
        </div>
        <div class="sub-title">
          {{ 'Get excited to never enter your username again.' | translate }}
        </div>
      </div>
    </div>
    <div class="right-side">
      <div class="flex flex-column center gap-30">
        <div class="title center">
          {{ 'Authentication successful. Redirecting you to Eyelation.' | translate }}
        </div>
        <div>
          <mat-spinner mode="indeterminate" diameter="100" color="#4471B8"></mat-spinner>
        </div>
      </div>
    </div>
  </section>
</div>
